import Skeleton from "Components/Common/Skeleton/Skeleton";
import { DrawDetail } from "../DrawHistory.types";
import { formatDate } from "utils/Common/Date";

interface SignaturesTabProps {
  drawDetail: DrawDetail | null;
  loading: boolean;
}

const SignaturesTab = ({ drawDetail, loading }: SignaturesTabProps) => {
  if (loading || !drawDetail) {
    return (
      <>
        <div className="sectionTitle">Signatures</div>
        <div className="sigLine">
          <Skeleton width={300} height={24} borderRadius={4} />
        </div>
        <div className="sigBlock">
          {["Owner / Borrower", "General Contractor"].map((label) => (
            <div className="sigCard" key={label}>
              <div className="sigHeader">
                {label}
                <Skeleton
                  width={70}
                  height={16}
                  borderRadius={10}
                  className="sigHeaderSkeleton"
                />
              </div>
              <div className="sigBody">
                {[1, 2, 3].map((i) => (
                  <div className="sigLine" key={i}>
                    <Skeleton width={40} height={24} borderRadius={4} />
                    <Skeleton width={90} height={24} borderRadius={4} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </>
    );
  }

  const owner = drawDetail.signatures?.owner;
  const gc = drawDetail.signatures?.gc;
  const ownerSigned = !!owner?.signatureUrl;
  const gcSigned = !!gc?.signatureUrl;

  return (
    <>
      <div className="sectionTitle">Signatures</div>
      <div className="sectionSub">
        {/* Signature status for Draw #
        {String(drawDetail.draw.drawNumber).padStart(2, "0")}. */}
        All required signatures for Draw #
        {String(drawDetail.draw.drawNumber).padStart(2, "0")}. Both borrower and
        GC signatures were obtained before submission.
      </div>

      <div className="sigBlock">
        <div className="sigCard">
          <div className="sigHeader">
            Owner / Borrower
            <span className={`docStatus ${ownerSigned ? "signed" : "missing"}`}>
              {ownerSigned ? "✓ Signed" : "Not Signed"}
            </span>
          </div>
          <div className="sigBody">
            <div className="sigLine">
              <span className="sigLabel">Name</span>
              <span className="sigValue">{owner?.name ?? "—"}</span>
            </div>
            <div className="sigLine">
              <span className="sigLabel">Title</span>
              <span className="sigValue">{owner?.designation ?? "—"}</span>
            </div>
            <div className="sigLine">
              <span className="sigLabel">Date</span>
              <span className="sigValue">
                {owner?.signedAt ? formatDate(owner.signedAt, false) : "—"}
              </span>
            </div>
            {ownerSigned && (
              <div className="sigImage">
                {" "}
                <img src={owner?.signatureUrl} alt="" /> {owner?.name ?? "—"}
              </div>
            )}
          </div>
        </div>

        <div className="sigCard">
          <div className="sigHeader">
            General Contractor
            <span className={`docStatus ${gcSigned ? "signed" : "missing"}`}>
              {gcSigned ? "✓ Signed" : "Not Signed"}
            </span>
          </div>
          <div className="sigBody">
            <div className="sigLine">
              <span className="sigLabel">Name</span>
              <span className="sigValue">{gc?.name ?? "—"}</span>
            </div>
            <div className="sigLine">
              <span className="sigLabel">Title</span>
              <span className="sigValue">{gc?.designation ?? "—"}</span>
            </div>
            <div className="sigLine">
              <span className="sigLabel">Date</span>
              <span className="sigValue">
                {gc?.signedAt ? formatDate(gc.signedAt, false) : "—"}
              </span>
            </div>
            {gcSigned && (
              <div className="sigImage">
                <img src={gc?.signatureUrl} alt="" /> {gc?.name ?? "—"}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SignaturesTab;
